var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-controls"},[(_vm.hasQueryChanged || _vm.isSearchCanceled)?_c('v-btn',{staticClass:"mx-1",attrs:{"x-small":"","color":"primary"},on:{"click":_vm.createSearch}},[_vm._v(" Run Search ")]):_vm._e(),(_vm.hasQueryChanged)?_c('v-btn',{attrs:{"x-small":""},on:{"click":_vm.cancelSearch}},[_vm._v(" Cancel ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }